import React from "react";
import Icon from "../Icon/Icon";
import Skeleton from "../layout/Skeleton/Skeleton";

const LeadScore: React.FC<{
  value: number;
  threshold?: number;
  loading: boolean;
  removeBg?: boolean;
  iconName?: string;
}> = ({ value, iconName, threshold, loading, removeBg = false }) => {
  if (loading || !threshold) return <Skeleton width={40} height={25} />;
  //  if (value === undefined) value = 0;
  const level =
    value <= threshold * 0.33
      ? "low"
      : value <= threshold * 0.66
      ? "medium"
      : "high";
  const style =
    level === "high"
      ? `bg-greendark-500 text-greenlight-300 font-semibold`
      : level === "medium"
      ? `bg-yellowdark-500 text-yellowlight-300 font-semibold`
      : `bg-reddark-500 text-redlight-300 font-semibold`;
  if (removeBg) {
    return (
      <div className="flex w-full justify-center items-center">
        <div
          className={` flex gap-2 w-fit justify-around items-center text-sm ${style} !bg-transparent flex p-0 !text-[26px]`}
        >
          <Icon
            size={26}
            name={
              iconName
                ? iconName
                : level === "high"
                ? `star`
                : level === "medium"
                ? `face-meh`
                : `thumbs-down`
            }
          />
          {value}
        </div>
      </div>
    );
  }
  return (
    <div className="flex w-full justify-center items-center">
      <div
        className={`rounded-md flex  w-fit text-sm justify-between px-3 max-h-[24px] gap-2 items-center  ${style} py-4`}
      >
        <Icon
          size={18}
          name={
            iconName
              ? iconName
              : level === "high"
              ? `star`
              : level === "medium"
              ? `face-meh`
              : `thumbs-down`
          }
        />
        {value}
      </div>
    </div>
  );
};
export default LeadScore;
